import React, { useState } from 'react';

const C = {
 accent:'#3AAF58', accentLight:'#EAF7EE',
 bg:'#0A1628', surface:'#0F2040',
 border:'rgba(30,58,95,.8)', border2:'rgba(30,58,95,1)',
 text:'#F0F2FF', text2:'#A0A8C0', text3:'#606880',
 amber:'#D4840F', amberBg:'rgba(245,158,11,.1)', amberBorder:'#F0D499',
 red:'#EF4444', redBg:'rgba(239,68,68,.1)', redBorder:'#F0B8B8',
 blue:'#FFFFFF', blueBg:'#EAF1FB', blueBorder:'#B8D0F0',
 purple:'#6B48A8', purpleBg:'#F0EBFB', purpleBorder:'#C8B8F0',
 teal:'#1A7A7A', tealBg:'#E7F5F5',
 pink:'#C2185B', pinkBg:'#FCE4EC',
 dark:'#0F1E14',
};

const inr = n => '₹' + Number(Math.round(n)||0).toLocaleString('en-IN');
const todayStr = () => new Date().toISOString().slice(0,10);

// ── SAMPLE DATA ──────────────────────────────────────────────────────────────
const CAMPAIGNS = [
 {id:1,name:'Monsoon Staycation Offer',type:'Email + WhatsApp',status:'Active',budget:25000,spent:18400,leads:142,conversions:28,revenue:840000,startDate:'2026-06-01',endDate:'2026-08-31',channel:['Email','WhatsApp','Instagram'],target:'FIT Leisure',desc:'Monsoon package promotion with 20% off'},
 {id:2,name:'Corporate Diwali Package',type:'Corporate Outreach',status:'Active',budget:40000,spent:12000,leads:67,conversions:11,revenue:1540000,startDate:'2026-09-01',endDate:'2026-10-31',channel:['Email','LinkedIn','Direct Call'],target:'Corporate HR',desc:'Diwali team outing packages for corporate clients'},
 {id:3,name:'Wedding Season 2026-27',type:'Multi-channel',status:'Planning',budget:80000,spent:0,leads:0,conversions:0,revenue:0,startDate:'2026-10-01',endDate:'2027-02-28',channel:['Instagram','Facebook','Google Ads','Wedding Portals'],target:'Wedding Planners',desc:'Premium wedding destination campaign'},
 {id:4,name:'School Picnic Drive Q3',type:'Direct Outreach',status:'Completed',budget:15000,spent:14200,leads:89,conversions:34,revenue:2890000,startDate:'2026-04-01',endDate:'2026-06-30',channel:['Email','Direct Visit','Phone'],target:'School Principals',desc:'Q3 school picnic season campaign'},
 {id:5,name:'New Year Bash 2027',type:'Social Media',status:'Planning',budget:50000,spent:5000,leads:23,conversions:4,revenue:480000,startDate:'2026-11-01',endDate:'2026-12-31',channel:['Instagram','Facebook','Google Ads'],target:'Premium FIT',desc:'New Year Eve party and staycation'},
];

const EVENTS_CALENDAR = [
 {id:1,title:'Corporate Team Outing – Tech Mahindra',date:'2026-07-05',type:'Corporate',status:'Confirmed',pax:120,value:216000,owner:'Pooja Rawat',venue:'Adventure Zone + Lawn',color:C.blue},
 {id:2,title:'School Picnic – DPS Gurugram',date:'2026-07-08',type:'School Picnic',status:'Confirmed',pax:180,value:171000,owner:'Rajesh Sharma',venue:'Full Resort',color:C.teal},
 {id:3,title:'Wedding – Kapoor Family',date:'2026-07-12',type:'Wedding',status:'Tentative',pax:350,value:2183000,owner:'Pooja Rawat',venue:'Central Lawn + Banquet',color:C.pink},
 {id:4,title:'Instagram Reels Shoot',date:'2026-07-14',type:'Content Creation',status:'Planned',pax:5,value:0,owner:'Marketing Team',venue:'Multiple Spots',color:C.purple},
 {id:5,title:'Corporate Day Out – HDFC Bank',date:'2026-07-18',type:'Corporate',status:'Confirmed',pax:95,value:171000,owner:'Pooja Rawat',venue:'Adventure Zone',color:C.blue},
 {id:6,title:'Monsoon Festival Weekend',date:'2026-07-19',type:'In-house Event',status:'Planned',pax:200,value:500000,owner:'Rajesh Sharma',venue:'Open Amphitheatre',color:C.accent},
 {id:7,title:'Wedding – Sharma Family',date:'2026-07-25',type:'Wedding',status:'Confirmed',pax:250,value:1850000,owner:'Pooja Rawat',venue:'Garden Lawn',color:C.pink},
 {id:8,title:'School Picnic – St. Columbus',date:'2026-07-28',type:'School Picnic',status:'Tentative',pax:140,value:133000,owner:'Pooja Rawat',venue:'Activity Zone',color:C.teal},
 {id:9,title:'Google Ads Campaign Launch',date:'2026-08-01',type:'Digital Marketing',status:'Planned',pax:0,value:30000,owner:'Marketing Team',venue:'Online',color:C.amber},
 {id:10,title:'Press Release – Resort Expansion',date:'2026-08-05',type:'PR Activity',status:'Planned',pax:15,value:0,owner:'Rajesh Sharma',venue:'Conference Hall',color:C.red},
];

const SOCIAL_CHANNELS = [
 {name:'Instagram',handle:'@botanixresort',followers:12400,posts:286,engagement:'4.8%',reach:'38K',color:'#E4405F',trend:'+340 this month'},
 {name:'Facebook',handle:'Botanix Nature Resort',followers:8900,posts:412,engagement:'3.2%',reach:'22K',color:'#1877F2',trend:'+120 this month'},
 {name:'Google Business',handle:'Botanix Nature Resort',followers:0,posts:0,engagement:'',reach:'15K views',color:'#4285F4',trend:'4.6 (234 reviews)'},
 {name:'WhatsApp Broadcast',handle:'Botanix Updates',followers:2340,posts:48,engagement:'62%',reach:'2.3K',color:'#25D366',trend:'62% open rate'},
 {name:'YouTube',handle:'Botanix Resort',followers:1820,posts:34,engagement:'5.1%',reach:'45K views',color:'#FF0000',trend:'+2 videos this month'},
 {name:'LinkedIn',handle:'Botanix Nature Resort',followers:3200,posts:89,engagement:'2.8%',reach:'18K',color:'#0A66C2',trend:'Corporate focus'},
];

const CONTENT_CALENDAR = [
 {id:1,date:'2026-07-03',platform:'Instagram',type:'Reel',topic:'Monsoon magic at Botanix – rain dance activity',status:'Scheduled',assignedTo:'Digital Team',caption:'Let the rain wash away your stress! Join us for our Monsoon Splash package this July.'},
 {id:2,date:'2026-07-05',platform:'WhatsApp',type:'Broadcast',topic:'Corporate package offer – weekend exclusive',status:'Scheduled',assignedTo:'Pooja Rawat',caption:''},
 {id:3,date:'2026-07-07',platform:'Facebook',type:'Post',topic:'Wedding venue showcase – Central Lawn',status:'Draft',assignedTo:'Digital Team',caption:''},
 {id:4,date:'2026-07-10',platform:'Instagram',type:'Story',topic:'Chef special – monsoon thali',status:'Draft',assignedTo:'Digital Team',caption:''},
 {id:5,date:'2026-07-12',platform:'YouTube',type:'Video',topic:'Full resort tour – 2026 edition',status:'In Progress',assignedTo:'Video Team',caption:''},
 {id:6,date:'2026-07-14',platform:'LinkedIn',type:'Post',topic:'Corporate team building case study',status:'Draft',assignedTo:'Pooja Rawat',caption:''},
 {id:7,date:'2026-07-17',platform:'Instagram',type:'Carousel',topic:'10 reasons to choose Botanix for your wedding',status:'Planned',assignedTo:'Digital Team',caption:''},
 {id:8,date:'2026-07-20',platform:'Google Ads',type:'Campaign',topic:'Monsoon getaway – keyword campaign',status:'Active',assignedTo:'Agency',caption:''},
 {id:9,date:'2026-07-22',platform:'Facebook',type:'Reel',topic:'Adventure activities compilation',status:'Planned',assignedTo:'Video Team',caption:''},
 {id:10,date:'2026-07-25',platform:'WhatsApp',type:'Broadcast',topic:'New Year Bash early bird announcement',status:'Planned',assignedTo:'Pooja Rawat',caption:''},
];

const LEADS_PIPELINE = [
 {id:1,name:'Gupta Family Wedding',source:'Instagram DM',stage:'Hot',value:2800000,followUp:'2026-07-03',owner:'Pooja Rawat',lastContact:'Yesterday',phone:'9810012345'},
 {id:2,name:'Infosys Team Outing',source:'LinkedIn',stage:'Warm',value:350000,followUp:'2026-07-05',owner:'Pooja Rawat',lastContact:'2 days ago',phone:'9810023456'},
 {id:3,name:'MRF Corporate Picnic',source:'Direct Call',stage:'Hot',value:480000,followUp:'2026-07-04',owner:'Rajesh Sharma',lastContact:'Today',phone:'9810034567'},
 {id:4,name:'Delhi Public School',source:'Email Campaign',stage:'Warm',value:190000,followUp:'2026-07-08',owner:'Pooja Rawat',lastContact:'3 days ago',phone:'9810045678'},
 {id:5,name:'Mehta Wedding (Dec)',source:'Wedding Portal',stage:'New',value:3200000,followUp:'2026-07-10',owner:'Pooja Rawat',lastContact:'Today',phone:'9810056789'},
 {id:6,name:'Wipro Annual Outing',source:'Corporate Database',stage:'Cold',value:650000,followUp:'2026-07-15',owner:'Rajesh Sharma',lastContact:'1 week ago',phone:'9810067890'},
];

const BUDGETS = [
 {category:'Google Ads',allocated:60000,spent:22000,color:C.blue},
 {category:'Instagram / Meta Ads',allocated:45000,spent:18000,color:C.pink},
 {category:'WhatsApp Marketing',allocated:15000,spent:8000,color:C.accent},
 {category:'Content Creation',allocated:30000,spent:12000,color:C.purple},
 {category:'Email Marketing',allocated:10000,spent:4500,color:C.teal},
 {category:'PR & Media',allocated:25000,spent:0,color:C.amber},
 {category:'Events & Activations',allocated:50000,spent:15000,color:C.red},
 {category:'SEO / Website',allocated:20000,spent:20000,color:C.blue},
];

// ── ATOMS ─────────────────────────────────────────────────────────────────────
const Card = ({children,style={}}) => <div style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:12,boxShadow:'0 1px 4px rgba(0,0,0,.05)',...style}}>{children}</div>;
const SH = ({title,icon,color,bg,right}) => (
 <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'13px 18px',borderBottom:`1px solid ${C.border}`,background:bg||'#F5F8F5',borderRadius:'12px 12px 0 0'}}>
 <div style={{display:'flex',alignItems:'center',gap:8}}><span style={{fontSize:18}}>{icon}</span><span style={{fontSize:14,fontWeight:700,color:color||C.text}}>{title}</span></div>
 {right}
 </div>
);
const Btn = ({children,onClick,variant='primary',style={},disabled}) => {
 const v={primary:{background:C.accent,color:'#fff',border:'none'},danger:{background:C.red,color:'#fff',border:'none'},ghost:{background:'transparent',color:C.text2,border:`1px solid ${C.border2}`},outline:{background:'transparent',color:C.accent,border:`1px solid ${C.accent}`},light:{background:C.accentLight,color:C.accent,border:'none'},amber:{background:C.amberBg,color:C.amber,border:`1px solid ${C.amberBorder}`},purple:{background:C.purpleBg,color:C.purple,border:`1px solid ${C.purpleBorder}`}};
 return <button onClick={onClick} disabled={disabled} style={{...v[variant],padding:'8px 16px',borderRadius:8,fontSize:13,fontWeight:600,cursor:disabled?'not-allowed':'pointer',opacity:disabled?.5:1,display:'inline-flex',alignItems:'center',gap:6,whiteSpace:'nowrap',...style}}>{children}</button>;
};
const Inp = ({label,value,onChange,type='text',opts,placeholder='',required}) => {
 const base={width:'100%',padding:'9px 12px',background:C.bg,border:`1px solid ${C.border2}`,borderRadius:8,color:C.text,fontSize:13,fontFamily:'Inter,sans-serif',boxSizing:'border-box'};
 return (
 <div style={{marginBottom:12}}>
 {label&&<div style={{fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',letterSpacing:'.05em',marginBottom:5}}>{label}{required&&<span style={{color:C.red}}> *</span>}</div>}
 {opts?<select style={base} value={value} onChange={e=>onChange(e.target.value)}>{opts.map(o=><option style={{background:'#0F2040',color:'#F0F2FF'}} key={o}>{o}</option>)}</select>
 :type==='textarea'?<textarea rows={3} style={{...base,resize:'vertical'}} value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder}/>
 :<input type={type} style={base} value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder}/>}
 </div>
 );
};
const Th = ({c}) => <th style={{padding:'10px 14px',fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',letterSpacing:'.06em',textAlign:'left',background:'#F5F8F5',borderBottom:`1px solid ${C.border}`,whiteSpace:'nowrap'}}>{c}</th>;
const Td = ({children,style={}}) => <td style={{padding:'11px 14px',fontSize:13,borderBottom:`1px solid ${C.border}`,verticalAlign:'middle',...style}}>{children}</td>;
const Empty = ({icon,msg}) => <div style={{padding:'48px 20px',textAlign:'center'}}><div style={{fontSize:32,marginBottom:10}}>{icon}</div><div style={{color:C.text3,fontSize:14}}>{msg}</div></div>;
const KPI = ({label,value,icon,color,bg,sub,trend}) => (
 <Card style={{padding:18}}>
 <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:8}}>
 <div style={{fontSize:10,fontWeight:700,color:C.text3,textTransform:'uppercase',letterSpacing:'.07em'}}>{label}</div>
 <div style={{width:32,height:32,borderRadius:9,background:bg||C.accentLight,display:'flex',alignItems:'center',justifyContent:'center',fontSize:16}}>{icon}</div>
 </div>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:22,fontWeight:800,color:color||C.text,letterSpacing:'-.02em'}}>{value}</div>
 {sub&&<div style={{fontSize:11,color:C.text3,marginTop:3}}>{sub}</div>}
 {trend&&<div style={{fontSize:11,fontWeight:600,color:C.accent,marginTop:3}}>{trend}</div>}
 </Card>
);
const Modal = ({title,onClose,children,width='640px'}) => (
 <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.45)',zIndex:200,display:'flex',alignItems:'center',justifyContent:'center',padding:20}}>
 <Card style={{width,maxWidth:'100%',maxHeight:'92vh',overflow:'auto',padding:28,boxShadow:'0 24px 64px rgba(0,0,0,.2)'}}>
 <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:22}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:18,fontWeight:800,color:C.text}}>{title}</div>
 <button onClick={onClose} style={{background:C.bg,border:`1px solid ${C.border}`,borderRadius:8,width:32,height:32,cursor:'pointer',color:C.text2,fontSize:16,display:'flex',alignItems:'center',justifyContent:'center'}}></button>
 </div>
 {children}
 </Card>
 </div>
);

// ── CALENDAR VIEW ─────────────────────────────────────────────────────────────
function EventCalendar({events, onAdd}) {
 const [currentMonth, setCurrentMonth] = useState(new Date(2026,6,1));
 const [selectedDay, setSelectedDay] = useState(null);
 const [showForm, setShowForm] = useState(false);
 const [form, setForm] = useState({title:'',date:todayStr(),type:'Corporate',status:'Planned',pax:'',value:'',owner:'Pooja Rawat',venue:'',color:C.blue});

 const year = currentMonth.getFullYear();
 const month = currentMonth.getMonth();
 const firstDay = new Date(year, month, 1).getDay();
 const daysInMonth = new Date(year, month+1, 0).getDate();
 const monthNames = ['January','February','March','April','May','June','July','August','September','October','November','December'];
 const dayNames = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];

 const getEventsForDay = (day) => {
 const dateStr = `${year}-${String(month+1).padStart(2,'0')}-${String(day).padStart(2,'0')}`;
 return events.filter(e => e.date === dateStr);
 };

 const typeColors = {
 Corporate:C.blue, 'School Picnic':C.teal, Wedding:C.pink,
 'Content Creation':C.purple, 'In-house Event':C.accent,
 'Digital Marketing':C.amber, 'PR Activity':C.red, Meeting:C.text3,
 };

 return (
 <div>
 <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:20}}>
 <div style={{display:'flex',alignItems:'center',gap:12}}>
 <button onClick={()=>setCurrentMonth(new Date(year,month-1,1))} style={{width:34,height:34,borderRadius:9,border:`1px solid ${C.border2}`,background:C.surface,cursor:'pointer',fontSize:16,display:'flex',alignItems:'center',justifyContent:'center'}}></button>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:20,fontWeight:800,color:C.text,minWidth:200,textAlign:'center'}}>{monthNames[month]} {year}</div>
 <button onClick={()=>setCurrentMonth(new Date(year,month+1,1))} style={{width:34,height:34,borderRadius:9,border:`1px solid ${C.border2}`,background:C.surface,cursor:'pointer',fontSize:16,display:'flex',alignItems:'center',justifyContent:'center'}}></button>
 </div>
 <div style={{display:'flex',gap:10}}>
 <Btn onClick={()=>setCurrentMonth(new Date())} variant="ghost">Today</Btn>
 <Btn onClick={()=>setShowForm(true)}>+ Add Event</Btn>
 </div>
 </div>

 {/* Legend */}
 <div style={{display:'flex',gap:12,marginBottom:16,flexWrap:'wrap'}}>
 {Object.entries(typeColors).map(([type,color])=>(
 <div key={type} style={{display:'flex',alignItems:'center',gap:5}}>
 <div style={{width:10,height:10,borderRadius:3,background:color}}/>
 <span style={{fontSize:11,color:C.text3}}>{type}</span>
 </div>
 ))}
 </div>

 {/* Calendar Grid */}
 <Card>
 <div style={{display:'grid',gridTemplateColumns:'repeat(7,1fr)',background:C.dark,borderRadius:'12px 12px 0 0'}}>
 {dayNames.map(d=><div key={d} style={{padding:'10px',textAlign:'center',fontSize:12,fontWeight:700,color:'rgba(255,255,255,.5)',letterSpacing:'.06em',textTransform:'uppercase'}}>{d}</div>)}
 </div>
 <div style={{display:'grid',gridTemplateColumns:'repeat(7,1fr)',gap:0}}>
 {Array.from({length:firstDay}).map((_,i)=><div key={'empty'+i} style={{minHeight:100,borderRight:`1px solid ${C.border}`,borderBottom:`1px solid ${C.border}`,background:'#FAFCFA'}}/>)}
 {Array.from({length:daysInMonth}).map((_,i)=>{
 const day = i+1;
 const dayEvents = getEventsForDay(day);
 const isToday = day===2 && month===6 && year===2026;
 const isSelected = selectedDay===day;
 return (
 <div key={day} onClick={()=>setSelectedDay(day===selectedDay?null:day)}
 style={{minHeight:100,borderRight:`1px solid ${C.border}`,borderBottom:`1px solid ${C.border}`,padding:'6px',cursor:'pointer',background:isSelected?C.accentLight:isToday?'#F0FBF4':C.surface,transition:'background .15s'}}>
 <div style={{fontWeight:isToday?800:600,fontSize:13,color:isToday?C.accent:C.text,marginBottom:4,width:24,height:24,borderRadius:'50%',background:isToday?C.accent:'transparent',color:isToday?'#fff':C.text,display:'flex',alignItems:'center',justifyContent:'center'}}>{day}</div>
 {dayEvents.slice(0,2).map((ev,idx)=>(
 <div key={idx} style={{padding:'2px 6px',borderRadius:5,fontSize:10,fontWeight:600,color:'#fff',background:ev.color||typeColors[ev.type]||C.text3,marginBottom:2,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>
 {ev.title}
 </div>
 ))}
 {dayEvents.length>2&&<div style={{fontSize:10,color:C.text3,marginTop:2}}>+{dayEvents.length-2} more</div>}
 </div>
 );
 })}
 </div>
 </Card>

 {/* Selected day detail */}
 {selectedDay && (
 <Card style={{marginTop:16}}>
 <SH title={`${monthNames[month]} ${selectedDay}, ${year} — Events`} icon="" color={C.blue} bg={C.blueBg}/>
 <div style={{padding:18}}>
 {getEventsForDay(selectedDay).length===0
 ?<div style={{padding:'24px',textAlign:'center',color:C.text3}}>No events scheduled for this day. <button onClick={()=>setShowForm(true)} style={{color:C.accent,background:'none',border:'none',cursor:'pointer',fontWeight:600}}>+ Add one</button></div>
 :getEventsForDay(selectedDay).map((ev,i)=>(
 <div key={i} style={{display:'flex',alignItems:'flex-start',gap:14,padding:'14px',background:C.bg,borderRadius:10,marginBottom:10,border:`1px solid ${C.border}`,borderLeft:`4px solid ${ev.color||C.accent}`}}>
 <div style={{flex:1}}>
 <div style={{fontWeight:700,fontSize:14,color:C.text,marginBottom:4}}>{ev.title}</div>
 <div style={{display:'flex',gap:16,fontSize:12,color:C.text3,flexWrap:'wrap'}}>
 <span> {ev.venue}</span>
 <span> {ev.pax} pax</span>
 <span> {ev.owner}</span>
 {ev.value>0&&<span style={{color:C.accent,fontWeight:600}}>{inr(ev.value)}</span>}
 </div>
 </div>
 <span style={{padding:'3px 10px',borderRadius:99,fontSize:11,fontWeight:600,color:ev.status==='Confirmed'?C.accent:ev.status==='Tentative'?C.amber:C.text3,background:ev.status==='Confirmed'?C.accentLight:ev.status==='Tentative'?C.amberBg:C.border}}>{ev.status}</span>
 </div>
 ))}
 </div>
 </Card>
 )}

 {showForm && (
 <Modal title="Add Marketing Event" onClose={()=>setShowForm(false)} width="580px">
 <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10}}>
 <Inp label="Event Title" value={form.title} onChange={v=>setForm(p=>({...p,title:v}))} placeholder="e.g. Corporate Team Outing – XYZ Ltd" required/>
 <Inp label="Date" value={form.date} onChange={v=>setForm(p=>({...p,date:v}))} type="date"/>
 <Inp label="Event Type" value={form.type} onChange={v=>setForm(p=>({...p,type:v,color:typeColors[v]||C.blue}))} opts={['Corporate','School Picnic','Wedding','In-house Event','Digital Marketing','Content Creation','PR Activity','Press Conference','Influencer Visit','Trade Show','Meeting','Other']}/>
 <Inp label="Status" value={form.status} onChange={v=>setForm(p=>({...p,status:v}))} opts={['Planned','Tentative','Confirmed','Active','Completed','Cancelled']}/>
 <Inp label="Expected Pax" value={form.pax} onChange={v=>setForm(p=>({...p,pax:v}))} type="number" placeholder="100"/>
 <Inp label="Revenue Value (Rs.)" value={form.value} onChange={v=>setForm(p=>({...p,value:v}))} type="number" placeholder="150000"/>
 <Inp label="Venue" value={form.venue} onChange={v=>setForm(p=>({...p,venue:v}))} placeholder="e.g. Central Lawn"/>
 <Inp label="Owner / Manager" value={form.owner} onChange={v=>setForm(p=>({...p,owner:v}))} opts={['Pooja Rawat','Rajesh Sharma','Marketing Team','Digital Team','Video Team','Agency']}/>
 </div>
 <div style={{display:'flex',gap:10}}>
 <Btn onClick={()=>{if(!form.title)return;onAdd({id:Date.now(),...form,pax:parseInt(form.pax)||0,value:parseInt(form.value)||0});setShowForm(false);}} style={{flex:1,justifyContent:'center'}}>Add to Calendar</Btn>
 <Btn variant="ghost" onClick={()=>setShowForm(false)} style={{flex:1,justifyContent:'center'}}>Cancel</Btn>
 </div>
 </Modal>
 )}
 </div>
 );
}

// ── CAMPAIGN MANAGER ──────────────────────────────────────────────────────────
function CampaignManager({campaigns, setCampaigns}) {
 const [showForm, setShowForm] = useState(false);
 const [selected, setSelected] = useState(null);
 const [f, setF] = useState({name:'',type:'Email + WhatsApp',status:'Planning',budget:'',target:'',startDate:todayStr(),endDate:'',channel:[],desc:''});

 const statusColor = {Active:[C.accent,C.accentLight],Planning:[C.blue,C.blueBg],Completed:[C.text3,C.border],Paused:[C.amber,C.amberBg]};

 return (
 <div>
 <div style={{display:'grid',gridTemplateColumns:'repeat(5,1fr)',gap:12,marginBottom:20}}>
 <KPI label="Active Campaigns" value={campaigns.filter(c=>c.status==='Active').length} icon="" color={C.accent}/>
 <KPI label="Total Budget" value={inr(campaigns.reduce((s,c)=>s+c.budget,0))} icon="" color={C.blue} bg={C.blueBg}/>
 <KPI label="Total Spent" value={inr(campaigns.reduce((s,c)=>s+c.spent,0))} icon="" color={C.amber} bg={C.amberBg}/>
 <KPI label="Total Leads Generated" value={campaigns.reduce((s,c)=>s+c.leads,0)} icon="" color={C.purple} bg={C.purpleBg}/>
 <KPI label="Revenue Attributed" value={inr(campaigns.reduce((s,c)=>s+c.revenue,0))} icon="" color={C.accent} trend="From all campaigns"/>
 </div>

 <div style={{display:'flex',justifyContent:'flex-end',marginBottom:14}}>
 <Btn onClick={()=>setShowForm(true)}>+ New Campaign</Btn>
 </div>

 <div style={{display:'flex',flexDirection:'column',gap:14}}>
 {campaigns.map(c=>{
 const roiPct = c.spent>0?Math.round((c.revenue-c.spent)/c.spent*100):0;
 const spentPct = Math.round(c.spent/Math.max(c.budget,1)*100);
 const [sc,sbg]=statusColor[c.status]||[C.text3,C.border];
 return (
 <Card key={c.id}>
 <div style={{padding:'16px 20px'}}>
 <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:12}}>
 <div style={{flex:1}}>
 <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:4}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:16,fontWeight:800,color:C.text}}>{c.name}</div>
 <span style={{padding:'3px 10px',borderRadius:99,fontSize:11,fontWeight:600,color:sc,background:sbg}}>{c.status}</span>
 </div>
 <div style={{fontSize:12,color:C.text3,marginBottom:6}}>{c.desc}</div>
 <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
 {c.channel.map(ch=><span key={ch} style={{padding:'2px 8px',borderRadius:99,fontSize:10,fontWeight:600,color:C.blue,background:C.blueBg}}>{ch}</span>)}
 </div>
 </div>
 <div style={{textAlign:'right',marginLeft:20}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:20,fontWeight:800,color:C.accent}}>{inr(c.revenue)}</div>
 <div style={{fontSize:11,color:C.text3}}>revenue attributed</div>
 <div style={{fontSize:12,fontWeight:600,color:roiPct>0?C.accent:C.red,marginTop:4}}>ROI: {roiPct>0?'+':''}{roiPct}%</div>
 </div>
 </div>

 <div style={{display:'grid',gridTemplateColumns:'repeat(5,1fr)',gap:10,marginBottom:14}}>
 {[['Budget',inr(c.budget)],['Spent',inr(c.spent)],['Leads',c.leads],['Conversions',c.conversions],['Conv. Rate',c.leads>0?Math.round(c.conversions/c.leads*100)+'%':'—']].map(([k,v])=>(
 <div key={k} style={{padding:'10px',background:C.bg,borderRadius:9,textAlign:'center'}}>
 <div style={{fontSize:10,color:C.text3,fontWeight:700,textTransform:'uppercase',marginBottom:3}}>{k}</div>
 <div style={{fontSize:14,fontWeight:700,color:C.text}}>{v}</div>
 </div>
 ))}
 </div>

 <div style={{marginBottom:8}}>
 <div style={{display:'flex',justifyContent:'space-between',fontSize:11,color:C.text3,marginBottom:4}}>
 <span>Budget Utilization</span><span style={{fontWeight:600,color:spentPct>90?C.red:C.text2}}>{spentPct}%</span>
 </div>
 <div style={{height:6,background:C.border,borderRadius:99}}>
 <div style={{height:6,width:`${Math.min(spentPct,100)}%`,background:spentPct>90?C.red:spentPct>70?C.amber:C.accent,borderRadius:99}}/>
 </div>
 </div>

 <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
 <div style={{fontSize:12,color:C.text3}}>{c.startDate} → {c.endDate} · Target: {c.target}</div>
 <div style={{display:'flex',gap:8}}>
 <Btn variant="light" style={{padding:'5px 12px',fontSize:11}} onClick={()=>setSelected(c)}>Details</Btn>
 <Btn variant="ghost" style={{padding:'5px 12px',fontSize:11}}>Edit</Btn>
 </div>
 </div>
 </div>
 </Card>
 );
 })}
 </div>

 {showForm&&(
 <Modal title="Create Campaign" onClose={()=>setShowForm(false)} width="600px">
 <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10}}>
 <Inp label="Campaign Name" value={f.name} onChange={v=>setF(p=>({...p,name:v}))} required/>
 <Inp label="Campaign Type" value={f.type} onChange={v=>setF(p=>({...p,type:v}))} opts={['Email + WhatsApp','Social Media','Google Ads','Corporate Outreach','Multi-channel','Influencer','PR Campaign','Event Marketing']}/>
 <Inp label="Status" value={f.status} onChange={v=>setF(p=>({...p,status:v}))} opts={['Planning','Active','Paused','Completed']}/>
 <Inp label="Target Audience" value={f.target} onChange={v=>setF(p=>({...p,target:v}))} placeholder="e.g. Corporate HR Managers"/>
 <Inp label="Budget (Rs.)" value={f.budget} onChange={v=>setF(p=>({...p,budget:v}))} type="number"/>
 <Inp label="Start Date" value={f.startDate} onChange={v=>setF(p=>({...p,startDate:v}))} type="date"/>
 <Inp label="End Date" value={f.endDate} onChange={v=>setF(p=>({...p,endDate:v}))} type="date"/>
 </div>
 <Inp label="Description / Objective" value={f.desc} onChange={v=>setF(p=>({...p,desc:v}))} type="textarea" placeholder="Campaign objective and brief…"/>
 <div style={{display:'flex',gap:10}}>
 <Btn onClick={()=>{if(!f.name)return;setCampaigns(p=>[{id:Date.now(),...f,budget:parseFloat(f.budget)||0,spent:0,leads:0,conversions:0,revenue:0,channel:[f.type]},...p]);setShowForm(false);}} style={{flex:1,justifyContent:'center'}}>Create Campaign</Btn>
 <Btn variant="ghost" onClick={()=>setShowForm(false)} style={{flex:1,justifyContent:'center'}}>Cancel</Btn>
 </div>
 </Modal>
 )}
 </div>
 );
}

// ── CONTENT CALENDAR ──────────────────────────────────────────────────────────
function ContentCalendar({content, setContent}) {
 const [showForm, setShowForm] = useState(false);
 const [f, setF] = useState({date:todayStr(),platform:'Instagram',type:'Post',topic:'',status:'Draft',assignedTo:'Digital Team',caption:''});
 const platformColors={Instagram:'#E4405F',Facebook:'#1877F2',WhatsApp:'#25D366',YouTube:'#FF0000',LinkedIn:'#0A66C2','Google Ads':'#4285F4',Twitter:'#1DA1F2'};
 const statusColor={Scheduled:[C.accent,C.accentLight],Draft:[C.amber,C.amberBg],'In Progress':[C.blue,C.blueBg],Active:[C.accent,C.accentLight],Planned:[C.text3,C.border],Published:[C.purple,C.purpleBg]};

 return (
 <div>
 <div style={{display:'grid',gridTemplateColumns:'repeat(5,1fr)',gap:12,marginBottom:20}}>
 <KPI label="Total Content" value={content.length} icon=""/>
 <KPI label="Scheduled" value={content.filter(c=>c.status==='Scheduled').length} icon="" color={C.accent}/>
 <KPI label="In Progress" value={content.filter(c=>c.status==='In Progress').length} icon="" color={C.blue} bg={C.blueBg}/>
 <KPI label="Draft" value={content.filter(c=>c.status==='Draft').length} icon="" color={C.amber} bg={C.amberBg}/>
 <KPI label="Published" value={content.filter(c=>c.status==='Published').length} icon="" color={C.purple} bg={C.purpleBg}/>
 </div>

 <div style={{display:'flex',justifyContent:'flex-end',marginBottom:14}}>
 <Btn onClick={()=>setShowForm(true)}>+ Add Content</Btn>
 </div>

 <Card>
 <SH title="Content Calendar" icon="" color={C.purple} bg={C.purpleBg}/>
 <div style={{overflowX:'auto'}}>
 <table style={{width:'100%',borderCollapse:'collapse'}}>
 <thead><tr><Th c="Date"/><Th c="Platform"/><Th c="Type"/><Th c="Topic"/><Th c="Assigned To"/><Th c="Status"/><Th c="Action"/></tr></thead>
 <tbody>
 {content.map(c=>{
 const [sc,sbg]=statusColor[c.status]||[C.text3,C.border];
 const pc=platformColors[c.platform]||C.text3;
 return (
 <tr key={c.id} style={{borderBottom:`1px solid ${C.border}`}}>
 <Td style={{fontSize:12,color:C.text3,whiteSpace:'nowrap'}}>{c.date}</Td>
 <Td>
 <div style={{display:'flex',alignItems:'center',gap:6}}>
 <div style={{width:8,height:8,borderRadius:'50%',background:pc}}/>
 <span style={{fontSize:13,fontWeight:600,color:pc}}>{c.platform}</span>
 </div>
 </Td>
 <Td><span style={{padding:'2px 8px',borderRadius:6,fontSize:11,fontWeight:600,background:C.bg,color:C.text2,border:`1px solid ${C.border}`}}>{c.type}</span></Td>
 <Td style={{maxWidth:220}}><div style={{fontSize:13,fontWeight:500,color:C.text}}>{c.topic}</div></Td>
 <Td style={{fontSize:12,color:C.text3}}>{c.assignedTo}</Td>
 <Td><span style={{padding:'3px 9px',borderRadius:99,fontSize:11,fontWeight:600,color:sc,background:sbg}}>{c.status}</span></Td>
 <Td>
 <div style={{display:'flex',gap:5}}>
 <Btn variant="light" style={{padding:'4px 8px',fontSize:11}}>Edit</Btn>
 <Btn variant="ghost" style={{padding:'4px 8px',fontSize:11}} onClick={()=>setContent(p=>p.map(x=>x.id===c.id?{...x,status:'Published'}:x))}>Publish</Btn>
 </div>
 </Td>
 </tr>
 );
 })}
 </tbody>
 </table>
 </div>
 </Card>

 {showForm&&(
 <Modal title="Add Content Piece" onClose={()=>setShowForm(false)} width="580px">
 <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10}}>
 <Inp label="Date" value={f.date} onChange={v=>setF(p=>({...p,date:v}))} type="date"/>
 <Inp label="Platform" value={f.platform} onChange={v=>setF(p=>({...p,platform:v}))} opts={['Instagram','Facebook','WhatsApp','YouTube','LinkedIn','Google Ads','Twitter','Website Blog']}/>
 <Inp label="Content Type" value={f.type} onChange={v=>setF(p=>({...p,type:v}))} opts={['Post','Reel','Story','Video','Carousel','Broadcast','Blog','Campaign','Ad Creative']}/>
 <Inp label="Status" value={f.status} onChange={v=>setF(p=>({...p,status:v}))} opts={['Draft','In Progress','Scheduled','Active','Published']}/>
 <Inp label="Assigned To" value={f.assignedTo} onChange={v=>setF(p=>({...p,assignedTo:v}))} opts={['Digital Team','Video Team','Pooja Rawat','Rajesh Sharma','Agency']}/>
 </div>
 <Inp label="Topic / Title" value={f.topic} onChange={v=>setF(p=>({...p,topic:v}))} placeholder="e.g. Monsoon package promotion reel…" required/>
 <Inp label="Caption / Copy" value={f.caption} onChange={v=>setF(p=>({...p,caption:v}))} type="textarea" placeholder="Post caption here…"/>
 <div style={{display:'flex',gap:10}}>
 <Btn onClick={()=>{if(!f.topic)return;setContent(p=>[{id:Date.now(),...f},...p]);setShowForm(false);}} style={{flex:1,justifyContent:'center'}}>Add to Calendar</Btn>
 <Btn variant="ghost" onClick={()=>setShowForm(false)} style={{flex:1,justifyContent:'center'}}>Cancel</Btn>
 </div>
 </Modal>
 )}
 </div>
 );
}

// ── LEADS PIPELINE ────────────────────────────────────────────────────────────
function LeadsPipeline({leads, setLeads}) {
 const stages=['New','Warm','Hot','Converted','Lost'];
 const stageColors={New:[C.blue,C.blueBg],Warm:[C.amber,C.amberBg],Hot:[C.red,C.redBg],Converted:[C.accent,C.accentLight],Lost:[C.text3,C.border]};
 const [showForm, setShowForm] = useState(false);
 const [f,setF]=useState({name:'',source:'Instagram DM',stage:'New',value:'',followUp:todayStr(),owner:'Pooja Rawat',phone:''});

 return (
 <div>
 <div style={{display:'grid',gridTemplateColumns:'repeat(5,1fr)',gap:12,marginBottom:20}}>
 {stages.map(s=>{
 const [c,bg]=stageColors[s];
 return <KPI key={s} label={s} value={leads.filter(l=>l.stage===s).length} icon={s==='Hot'?'':s==='Warm'?'':s==='Converted'?'':s==='Lost'?'':''} color={c} bg={bg} sub={inr(leads.filter(l=>l.stage===s).reduce((sum,l)=>sum+(parseInt(l.value)||0),0))}/>;
 })}
 </div>

 <div style={{display:'flex',justifyContent:'flex-end',marginBottom:14}}>
 <Btn onClick={()=>setShowForm(true)}>+ Add Lead</Btn>
 </div>

 {/* Kanban view */}
 <div style={{display:'grid',gridTemplateColumns:'repeat(5,1fr)',gap:12}}>
 {stages.map(stage=>{
 const [c,bg]=stageColors[stage];
 const stageLeads=leads.filter(l=>l.stage===stage);
 return (
 <div key={stage}>
 <div style={{padding:'8px 14px',background:bg,borderRadius:10,marginBottom:10,border:`1px solid ${c}33`,display:'flex',justifyContent:'space-between',alignItems:'center'}}>
 <span style={{fontSize:13,fontWeight:700,color:c}}>{stage}</span>
 <span style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:14,fontWeight:800,color:c}}>{stageLeads.length}</span>
 </div>
 <div style={{display:'flex',flexDirection:'column',gap:8}}>
 {stageLeads.map(lead=>(
 <Card key={lead.id} style={{padding:'12px 14px',border:`1px solid ${C.border}`,borderLeft:`3px solid ${c}`}}>
 <div style={{fontWeight:700,fontSize:13,color:C.text,marginBottom:4}}>{lead.name}</div>
 <div style={{fontSize:11,color:C.text3,marginBottom:6}}>{lead.source}</div>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:14,fontWeight:800,color:C.accent,marginBottom:6}}>{inr(parseInt(lead.value)||0)}</div>
 <div style={{fontSize:11,color:C.text3,marginBottom:8}}>Follow-up: {lead.followUp}</div>
 <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
 <span style={{fontSize:11,color:C.text3}}>{lead.owner?.split(' ')[0]}</span>
 <select value={lead.stage} onChange={e=>setLeads(p=>p.map(l=>l.id===lead.id?{...l,stage:e.target.value}:l))}
 style={{fontSize:10,padding:'2px 6px',borderRadius:6,border:`1px solid ${C.border2}`,background:C.bg,color:C.text,fontFamily:'Inter,sans-serif',cursor:'pointer'}}>
 {stages.map(s=><option style={{background:'#0F2040',color:'#F0F2FF'}} key={s}>{s}</option>)}
 </select>
 </div>
 </Card>
 ))}
 {stageLeads.length===0&&<div style={{padding:'20px',textAlign:'center',color:C.text3,fontSize:12,background:C.bg,borderRadius:10,border:`1px dashed ${C.border2}`}}>No leads</div>}
 </div>
 </div>
 );
 })}
 </div>

 {showForm&&(
 <Modal title="Add Lead" onClose={()=>setShowForm(false)} width="520px">
 <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10}}>
 <Inp label="Lead / Company Name" value={f.name} onChange={v=>setF(p=>({...p,name:v}))} required/>
 <Inp label="Source" value={f.source} onChange={v=>setF(p=>({...p,source:v}))} opts={['Instagram DM','Facebook','Google Ads','Website Enquiry','Walk-in','Referral','Corporate Database','Wedding Portal','School Database','Direct Call','LinkedIn','WhatsApp']}/>
 <Inp label="Stage" value={f.stage} onChange={v=>setF(p=>({...p,stage:v}))} opts={stages}/>
 <Inp label="Estimated Value (Rs.)" value={f.value} onChange={v=>setF(p=>({...p,value:v}))} type="number"/>
 <Inp label="Follow-up Date" value={f.followUp} onChange={v=>setF(p=>({...p,followUp:v}))} type="date"/>
 <Inp label="Phone" value={f.phone} onChange={v=>setF(p=>({...p,phone:v}))} placeholder="9810000000"/>
 <Inp label="Owner" value={f.owner} onChange={v=>setF(p=>({...p,owner:v}))} opts={['Pooja Rawat','Rajesh Sharma','Marketing Team']}/>
 </div>
 <div style={{display:'flex',gap:10}}>
 <Btn onClick={()=>{if(!f.name)return;setLeads(p=>[{id:Date.now(),...f,lastContact:'Just now'},...p]);setShowForm(false);}} style={{flex:1,justifyContent:'center'}}>Add Lead</Btn>
 <Btn variant="ghost" onClick={()=>setShowForm(false)} style={{flex:1,justifyContent:'center'}}>Cancel</Btn>
 </div>
 </Modal>
 )}
 </div>
 );
}


// ── SOCIAL MEDIA DASHBOARD ───────────────────────────────────────────────────
function SocialDashboard() {
 return (
 <div>
 <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:12,marginBottom:20}}>
 <KPI label="Total Followers" value="28.7K" icon="" color={C.purple} bg={C.purpleBg} trend="+580 this month"/>
 <KPI label="Total Reach" value="138K" icon="" color={C.blue} bg={C.blueBg} trend="Last 30 days"/>
 <KPI label="Avg Engagement" value="4.2%" icon="" color={C.pink} bg={C.pinkBg}/>
 <KPI label="Leads from Social" value="89" icon="" color={C.accent} trend="This month"/>
 </div>

 <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:14,marginBottom:20}}>
 {SOCIAL_CHANNELS.map(ch=>(
 <Card key={ch.name} style={{padding:'18px 20px'}}>
 <div style={{display:'flex',alignItems:'center',gap:12,marginBottom:14}}>
 <div style={{width:42,height:42,borderRadius:12,background:ch.color+'18',display:'flex',alignItems:'center',justifyContent:'center',fontSize:20}}>{ch.icon}</div>
 <div>
 <div style={{fontWeight:700,fontSize:15,color:C.text}}>{ch.name}</div>
 <div style={{fontSize:12,color:C.text3}}>{ch.handle}</div>
 </div>
 </div>
 <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10,marginBottom:12}}>
 {[['Followers',ch.followers>0?ch.followers.toLocaleString('en-IN'):'—'],['Reach',ch.reach],['Posts',ch.posts||'—'],['Engagement',ch.engagement||'—']].map(([k,v])=>(
 <div key={k} style={{padding:'8px',background:C.bg,borderRadius:8}}>
 <div style={{fontSize:10,color:C.text3,fontWeight:700,textTransform:'uppercase',marginBottom:2}}>{k}</div>
 <div style={{fontSize:13,fontWeight:700,color:C.text}}>{v}</div>
 </div>
 ))}
 </div>
 <div style={{fontSize:11,color:ch.color,fontWeight:600,padding:'6px 10px',background:ch.color+'12',borderRadius:8}}>{ch.trend}</div>
 </Card>
 ))}
 </div>

 <Card style={{padding:20}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:15,fontWeight:800,color:C.text,marginBottom:16}}>Quick Post Composer</div>
 <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16}}>
 <div>
 <div style={{fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',marginBottom:8}}>Platform</div>
 <div style={{display:'flex',gap:8,flexWrap:'wrap',marginBottom:14}}>
 {['Instagram','Facebook','WhatsApp','LinkedIn'].map(p=>(
 <button key={p} style={{padding:'6px 14px',borderRadius:8,border:`1px solid ${C.border2}`,background:C.bg,color:C.text2,fontSize:12,fontWeight:600,cursor:'pointer'}}>{p}</button>
 ))}
 </div>
 <div style={{fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',marginBottom:8}}>Caption</div>
 <textarea rows={5} placeholder="Write your post caption here… Include hashtags, emojis and CTA" style={{width:'100%',padding:'10px 12px',background:C.bg,border:`1px solid ${C.border2}`,borderRadius:9,color:C.text,fontSize:13,fontFamily:'Inter,sans-serif',resize:'vertical',boxSizing:'border-box'}}/>
 <div style={{display:'flex',gap:8,marginTop:10}}>
 <Btn style={{flex:1,justifyContent:'center'}}>Schedule Post</Btn>
 <Btn variant="outline" style={{flex:1,justifyContent:'center'}}>Post Now</Btn>
 </div>
 </div>
 <div>
 <div style={{fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',marginBottom:8}}>Suggested Hashtags</div>
 <div style={{display:'flex',flexWrap:'wrap',gap:6,marginBottom:14}}>
 {['#BotanixResort','#NatureRetreat','#HaryanaResort','#WeekendGetaway','#MonsoonVibes','#AdventureActivities','#WeddingVenue','#CorporateOuting','#NaturePhotography','#ResortLife','#Dharuhera','#NCRResort'].map(h=>(
 <span key={h} style={{padding:'4px 10px',borderRadius:99,fontSize:11,fontWeight:500,background:C.blueBg,color:C.blue,cursor:'pointer'}}>{h}</span>
 ))}
 </div>
 <div style={{fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',marginBottom:8}}>Best Posting Times</div>
 <div style={{display:'flex',flexDirection:'column',gap:6}}>
 {[['Instagram','7–9 AM, 6–8 PM','#E4405F'],['Facebook','12–2 PM, 7–9 PM','#1877F2'],['LinkedIn','8–10 AM (Tue–Thu)','#0A66C2'],['WhatsApp','10 AM, 5 PM','#25D366']].map(([p,t,c])=>(
 <div key={p} style={{display:'flex',justifyContent:'space-between',padding:'8px 12px',background:C.bg,borderRadius:8,fontSize:12}}>
 <span style={{fontWeight:600,color:c}}>{p}</span><span style={{color:C.text3}}>{t}</span>
 </div>
 ))}
 </div>
 </div>
 </div>
 </Card>
 </div>
 );
}

// ── BUDGET TRACKER ────────────────────────────────────────────────────────────
function BudgetTracker() {
 const [budgets, setBudgets] = useState(BUDGETS);
 const totalAllocated = budgets.reduce((s,b)=>s+b.allocated,0);
 const totalSpent = budgets.reduce((s,b)=>s+b.spent,0);
 const remaining = totalAllocated - totalSpent;

 return (
 <div>
 <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:12,marginBottom:20}}>
 <KPI label="Total Marketing Budget" value={inr(totalAllocated)} icon="" color={C.blue} bg={C.blueBg}/>
 <KPI label="Total Spent" value={inr(totalSpent)} icon="" color={C.amber} bg={C.amberBg} sub={`${Math.round(totalSpent/totalAllocated*100)}% utilized`}/>
 <KPI label="Remaining" value={inr(remaining)} icon="" color={remaining>0?C.accent:C.red}/>
 <KPI label="ROI" value="12.4x" icon="" color={C.accent} sub="Revenue per rupee spent"/>
 </div>

 <Card>
 <SH title="Marketing Budget Breakdown" icon="" color={C.blue} bg={C.blueBg}/>
 <div style={{padding:18}}>
 {budgets.map((b,i)=>{
 const pct = Math.round(b.spent/Math.max(b.allocated,1)*100);
 return (
 <div key={b.category} style={{marginBottom:18}}>
 <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:6}}>
 <div>
 <span style={{fontSize:14,fontWeight:600,color:C.text}}>{b.category}</span>
 </div>
 <div style={{display:'flex',gap:20,fontSize:12}}>
 <span style={{color:C.text3}}>Allocated: <strong style={{color:C.text}}>{inr(b.allocated)}</strong></span>
 <span style={{color:C.amber}}>Spent: <strong>{inr(b.spent)}</strong></span>
 <span style={{color:C.accent}}>Remaining: <strong>{inr(b.allocated-b.spent)}</strong></span>
 <span style={{fontWeight:700,color:pct>90?C.red:pct>70?C.amber:C.accent}}>{pct}%</span>
 </div>
 </div>
 <div style={{height:10,background:C.border,borderRadius:99}}>
 <div style={{height:10,width:`${Math.min(pct,100)}%`,background:pct>90?C.red:pct>70?C.amber:b.color,borderRadius:99,transition:'width .4s'}}/>
 </div>
 </div>
 );
 })}
 </div>
 </Card>

 <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16,marginTop:16}}>
 <Card style={{padding:20}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:14,fontWeight:800,color:C.text,marginBottom:14}}>Channel ROI Analysis</div>
 {[['Instagram / Meta',18000,840000],['Google Ads',22000,1200000],['WhatsApp Marketing',8000,650000],['Corporate Outreach',12000,2100000],['SEO / Website',20000,480000]].map(([ch,spent,rev])=>(
 <div key={ch} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'10px 12px',background:C.bg,borderRadius:9,marginBottom:8,border:`1px solid ${C.border}`}}>
 <div><div style={{fontSize:13,fontWeight:600,color:C.text}}>{ch}</div><div style={{fontSize:11,color:C.text3}}>Spent: {inr(spent)}</div></div>
 <div style={{textAlign:'right'}}>
 <div style={{fontSize:13,fontWeight:700,color:C.accent}}>{inr(rev)}</div>
 <div style={{fontSize:11,fontWeight:600,color:C.purple}}>ROI: {Math.round(rev/spent)}x</div>
 </div>
 </div>
 ))}
 </Card>

 <Card style={{padding:20}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:14,fontWeight:800,color:C.text,marginBottom:14}}>Monthly Spend Trend</div>
 {['Jan','Feb','Mar','Apr','May','Jun','Jul'].map((m,i)=>{
 const spend=[18000,22000,25000,20000,28000,32000,totalSpent][i];
 const max=35000;
 const color=[C.blue,C.blue,C.accent,C.accent,C.amber,C.red,C.accent][i];
 return (
 <div key={m} style={{display:'flex',alignItems:'center',gap:10,marginBottom:10}}>
 <div style={{width:32,fontSize:11,color:C.text3,fontWeight:600}}>{m}</div>
 <div style={{flex:1,height:8,background:C.border,borderRadius:99}}>
 <div style={{height:8,width:`${Math.min(spend/max*100,100)}%`,background:color,borderRadius:99}}/>
 </div>
 <div style={{width:70,textAlign:'right',fontSize:12,fontWeight:600,color:C.text}}>{inr(spend)}</div>
 </div>
 );
 })}
 </Card>
 </div>
 </div>
 );
}

// ── MARKETING DASHBOARD ───────────────────────────────────────────────────────
function MarketingDashboard({campaigns, events, leads}) {
 const totalLeads = leads.length;
 const hotLeads = leads.filter(l=>l.stage==='Hot').length;
 const converted = leads.filter(l=>l.stage==='Converted').length;
 const pipelineValue = leads.filter(l=>!['Converted','Lost'].includes(l.stage)).reduce((s,l)=>s+(parseInt(l.value)||0),0);

 return (
 <div>
 {/* Hero KPIs */}
 <div style={{background:`linear-gradient(135deg,${C.dark},#1A3A22)`,borderRadius:16,padding:'24px 28px',marginBottom:20}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:11,color:'rgba(255,255,255,.4)',textTransform:'uppercase',letterSpacing:'.1em',marginBottom:6}}>Marketing Command Centre — July 2026</div>
 <div style={{display:'grid',gridTemplateColumns:'repeat(6,1fr)',gap:16}}>
 {[['Active Campaigns',campaigns.filter(c=>c.status==='Active').length,'','rgba(58,175,88,.8)'],['Events This Month',events.length,'','rgba(255,255,255,.7)'],['Hot Leads',hotLeads,'','rgba(200,51,51,.8)'],['Pipeline Value',inr(pipelineValue),'','rgba(58,175,88,.8)'],['Conversions',converted,'','rgba(255,255,255,.7)'],['Total Followers','28.7K','','rgba(107,72,168,.8)']].map(([k,v,ic,c])=>(
 <div key={k} style={{padding:'14px',background:'rgba(255,255,255,.07)',borderRadius:12,backdropFilter:'blur(4px)'}}>
 <div style={{fontSize:18,marginBottom:8}}>{ic}</div>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:22,fontWeight:800,color:c,marginBottom:3}}>{v}</div>
 <div style={{fontSize:10,color:'rgba(255,255,255,.4)',textTransform:'uppercase',letterSpacing:'.06em'}}>{k}</div>
 </div>
 ))}
 </div>
 </div>

 <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16,marginBottom:16}}>
 {/* Upcoming Events */}
 <Card>
 <SH title="Upcoming Events (Next 30 Days)" icon="" color={C.blue} bg={C.blueBg}/>
 <div style={{padding:'14px 18px',display:'flex',flexDirection:'column',gap:8}}>
 {events.slice(0,5).map(ev=>(
 <div key={ev.id} style={{display:'flex',alignItems:'center',gap:12,padding:'10px 12px',background:C.bg,borderRadius:9,border:`1px solid ${C.border}`,borderLeft:`4px solid ${ev.color||C.accent}`}}>
 <div style={{textAlign:'center',minWidth:40}}>
 <div style={{fontSize:18,fontWeight:800,color:C.text,fontFamily:'Plus Jakarta Sans,sans-serif'}}>{ev.date.slice(8)}</div>
 <div style={{fontSize:10,color:C.text3,textTransform:'uppercase'}}>{['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][parseInt(ev.date.slice(5,7))-1]}</div>
 </div>
 <div style={{flex:1}}>
 <div style={{fontWeight:600,fontSize:13,color:C.text}}>{ev.title}</div>
 <div style={{fontSize:11,color:C.text3}}>{ev.type} · {ev.venue}</div>
 </div>
 <div style={{textAlign:'right'}}>
 {ev.value>0&&<div style={{fontSize:12,fontWeight:700,color:C.accent}}>{inr(ev.value)}</div>}
 <span style={{padding:'2px 8px',borderRadius:99,fontSize:10,fontWeight:600,color:ev.status==='Confirmed'?C.accent:ev.status==='Tentative'?C.amber:C.text3,background:ev.status==='Confirmed'?C.accentLight:ev.status==='Tentative'?C.amberBg:C.border}}>{ev.status}</span>
 </div>
 </div>
 ))}
 </div>
 </Card>

 {/* Hot Leads */}
 <Card>
 <SH title="Hot Leads — Need Immediate Action" icon="" color={C.red} bg={C.redBg}/>
 <div style={{padding:'14px 18px',display:'flex',flexDirection:'column',gap:8}}>
 {leads.filter(l=>l.stage==='Hot'||l.stage==='Warm').slice(0,5).map(lead=>(
 <div key={lead.id} style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'10px 14px',background:C.bg,borderRadius:9,border:`1px solid ${C.border}`,borderLeft:`4px solid ${lead.stage==='Hot'?C.red:C.amber}`}}>
 <div>
 <div style={{fontWeight:600,fontSize:13,color:C.text}}>{lead.name}</div>
 <div style={{fontSize:11,color:C.text3}}>{lead.source} · {lead.owner?.split(' ')[0]}</div>
 <div style={{fontSize:11,color:C.text3}}>Follow-up: {lead.followUp}</div>
 </div>
 <div style={{textAlign:'right'}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:14,fontWeight:800,color:C.accent}}>{inr(parseInt(lead.value)||0)}</div>
 <span style={{padding:'2px 8px',borderRadius:99,fontSize:10,fontWeight:600,color:lead.stage==='Hot'?C.red:C.amber,background:lead.stage==='Hot'?C.redBg:C.amberBg}}>{lead.stage}</span>
 </div>
 </div>
 ))}
 </div>
 </Card>
 </div>

 {/* Social + Campaign summary */}
 <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16}}>
 <Card style={{padding:20}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:14,fontWeight:800,color:C.text,marginBottom:14}}>Social Media Summary</div>
 {SOCIAL_CHANNELS.slice(0,4).map(ch=>(
 <div key={ch.name} style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'10px 12px',background:C.bg,borderRadius:9,marginBottom:8}}>
 <div style={{display:'flex',alignItems:'center',gap:10}}>
 <div style={{width:32,height:32,borderRadius:9,background:ch.color+'18',display:'flex',alignItems:'center',justifyContent:'center',fontSize:16}}>{ch.icon}</div>
 <div><div style={{fontSize:13,fontWeight:600,color:C.text}}>{ch.name}</div><div style={{fontSize:11,color:C.text3}}>{ch.engagement} engagement</div></div>
 </div>
 <div style={{textAlign:'right'}}>
 <div style={{fontSize:13,fontWeight:700,color:C.text}}>{ch.followers>0?ch.followers.toLocaleString('en-IN'):ch.reach}</div>
 <div style={{fontSize:10,color:C.text3}}>{ch.trend}</div>
 </div>
 </div>
 ))}
 </Card>

 <Card style={{padding:20}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:14,fontWeight:800,color:C.text,marginBottom:14}}>Active Campaign Performance</div>
 {campaigns.filter(c=>c.status==='Active').map(c=>(
 <div key={c.id} style={{padding:'12px',background:C.bg,borderRadius:9,marginBottom:10,border:`1px solid ${C.border}`}}>
 <div style={{display:'flex',justifyContent:'space-between',marginBottom:6}}>
 <div style={{fontWeight:600,fontSize:13,color:C.text}}>{c.name}</div>
 <div style={{fontSize:13,fontWeight:700,color:C.accent}}>{c.conversions} conv.</div>
 </div>
 <div style={{display:'flex',gap:16,fontSize:11,color:C.text3,marginBottom:6}}>
 <span>Leads: {c.leads}</span>
 <span>Spent: {inr(c.spent)}</span>
 <span>Revenue: {inr(c.revenue)}</span>
 </div>
 <div style={{height:5,background:C.border,borderRadius:99}}>
 <div style={{height:5,width:`${Math.min(Math.round(c.spent/Math.max(c.budget,1)*100),100)}%`,background:C.accent,borderRadius:99}}/>
 </div>
 </div>
 ))}
 </Card>
 </div>
 </div>
 );
}

// ── MAIN MARKETING MODULE ─────────────────────────────────────────────────────
const MKT_TABS = [
 {id:'dashboard', label:'Dashboard', },
 {id:'campaigns', label:'Campaigns', },
 {id:'calendar', label:'Event Calendar', },
 {id:'content', label:'Content Calendar', },
 {id:'leads', label:'Leads Pipeline', },
 {id:'social', label:'Social Media', },
 {id:'budget', label:'Budget & ROI', },
];

export default function Marketing() {
 const [tab, setTab] = useState('dashboard');
 const [campaigns, setCampaigns] = useState(CAMPAIGNS);
 const [events, setEvents] = useState(EVENTS_CALENDAR);
 const [content, setContent] = useState(CONTENT_CALENDAR);
 const [leads, setLeads] = useState(LEADS_PIPELINE);

 const hotLeads = leads.filter(l=>l.stage==='Hot').length;
 const pendingContent = content.filter(c=>c.status==='Draft'||c.status==='In Progress').length;

 return (
 <div style={{fontFamily:'Inter,sans-serif',color:C.text}}>
 {/* Top Bar */}
 <div style={{background:C.surface,borderBottom:`1px solid ${C.border}`,padding:'0 28px',position:'sticky',top:0,zIndex:50}}>
 <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',height:62}}>
 <div>
 <div style={{fontSize:11,color:C.text3,fontWeight:500,marginBottom:1}}>Sales & Growth</div>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:20,fontWeight:800,color:C.text,letterSpacing:'-.02em'}}>Marketing Command Centre</div>
 </div>
 <div style={{display:'flex',gap:10,alignItems:'center'}}>
 <div style={{padding:'7px 14px',background:hotLeads>0?C.redBg:C.accentLight,borderRadius:9,border:`1px solid ${hotLeads>0?C.redBorder:'#A8D8B8'}`}}>
 <span style={{fontSize:12,fontWeight:700,color:hotLeads>0?C.red:C.accent}}>{hotLeads} Hot Leads Need Follow-up</span>
 </div>
 <Btn onClick={()=>setTab('campaigns')}>+ New Campaign</Btn>
 </div>
 </div>
 <div style={{display:'flex',gap:0,overflowX:'auto'}}>
 {MKT_TABS.map(t=>(
 <button key={t.id} onClick={()=>setTab(t.id)}
 style={{padding:'10px 14px',background:'transparent',border:'none',cursor:'pointer',fontSize:13,fontWeight:600,color:tab===t.id?C.accent:C.text3,borderBottom:`2px solid ${tab===t.id?C.accent:'transparent'}`,whiteSpace:'nowrap',display:'flex',alignItems:'center',gap:5}}>
 {t.icon} {t.label}
 {t.id==='leads'&&hotLeads>0&&<span style={{padding:'1px 5px',borderRadius:99,fontSize:10,background:C.redBg,color:C.red}}>{hotLeads}</span>}
 {t.id==='content'&&pendingContent>0&&<span style={{padding:'1px 5px',borderRadius:99,fontSize:10,background:C.amberBg,color:C.amber}}>{pendingContent}</span>}
 </button>
 ))}
 </div>
 </div>

 <div style={{padding:'24px 28px'}}>
 {tab==='dashboard' && <MarketingDashboard campaigns={campaigns} events={events} leads={leads}/>}
 {tab==='campaigns' && <CampaignManager campaigns={campaigns} setCampaigns={setCampaigns}/>}
 {tab==='calendar' && <EventCalendar events={events} onAdd={ev=>setEvents(p=>[ev,...p])}/>}
 {tab==='content' && <ContentCalendar content={content} setContent={setContent}/>}
 {tab==='leads' && <LeadsPipeline leads={leads} setLeads={setLeads}/>}
 {tab==='social' && <SocialDashboard/>}
 {tab==='budget' && <BudgetTracker/>}
 </div>
 </div>
 );
}
